export default __webpack_public_path__ + "static/media/YAS0910.34I-41427_-24741_0.5dfcd45f.jpg";